import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VModal from "vue-js-modal";
import Tabs from "vue-tabs-component";

Vue.use(Tabs);
Vue.use(VModal);
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
